import { render, staticRenderFns } from "./SbBackground.vue?vue&type=template&id=c62b08c6&scoped=true"
import script from "./SbBackground.vue?vue&type=script&lang=js"
export * from "./SbBackground.vue?vue&type=script&lang=js"
import style0 from "./SbBackground.vue?vue&type=style&index=0&id=c62b08c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62b08c6",
  null
  
)

export default component.exports